import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postJackpotIssue = (params) => {
    return axios.post(`${backendHost}/api/admin/jackpot/issue`, params);
};

export {
    postJackpotIssue
}